export default {
  CONSTRUCT() {
    return {
      active: 'documentation'
    };
  },
  SWITCH_TAB(state, tab) {
    return state.set('active', tab.props.value);
  }
};
